import { ProductInfo } from "@insite/client-framework/Common/ProductInfo";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { HasShellContext } from "@insite/client-framework/Components/IsInShell";
import { ProductContextModel } from "@insite/client-framework/Components/ProductContext";
import { getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import translate from "@insite/client-framework/Translate";
import { CartLineModel, OrderLineModel } from "@insite/client-framework/Types/ApiModels";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import SearchTextField, { SearchTextFieldStyles } from "@insite/content-library/Widgets/OrderHistory/SearchTextField";
import DataTable from "@insite/mobius/DataTable/DataTable";
import DataTableBody from "@insite/mobius/DataTable/DataTableBody";
import DataTableCell, { DataTableCellProps } from "@insite/mobius/DataTable/DataTableCell";
import DataTableHead from "@insite/mobius/DataTable/DataTableHead";
import DataTableHeader, { DataTableHeaderProps } from "@insite/mobius/DataTable/DataTableHeader";
import DataTableRow from "@insite/mobius/DataTable/DataTableRow";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import Link from "@insite/mobius/Link/Link";
import LoadingSpinner, { LoadingSpinnerProps } from "@insite/mobius/LoadingSpinner/LoadingSpinner";
import { HasHistory, withHistory } from "@insite/mobius/utilities/HistoryContext";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import PurchasedItems from "@theStellarBlueprint/Components/PurchasedItems";
import { UserDetailsModel } from "@theStellarBlueprint/CustomApiModels";
import CustomApplicationState from "@theStellarBlueprint/Store/CustomApplicationState";
import loadPurchasedItems from "@theStellarBlueprint/Store/Data/PurchasedItems/Handlers/LoadPurchasedItems";
import { getPurchasedItemsData } from "@theStellarBlueprint/Store/Data/PurchasedItems/LoadPurchasedItemsSelector";
import UpdatePurchasedItemsConfigSelection from "@theStellarBlueprint/Store/Data/PurchasedItemsConfig/Handlers/LoadPurchasedItemsConfigHandler";
import { getPurchasedItemsConfigSelectionState } from "@theStellarBlueprint/Store/Data/PurchasedItemsConfig/LoadPurchasedItemsConfigSelector";
import { PurchasedItemsConfigParameter } from "@theStellarBlueprint/Store/Data/PurchasedItemsConfig/LoadPurchasedItemsConfigState";
import * as React from "react";
import { useEffect } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css, ThemeProps } from "styled-components";

const enum configKey {
    page = "page",
    Search = "Search",
    Description = "Description",
    pageSize = "pageSize",
    fromDate="fromDate",
    toDate="toDate"
}

const mapDispatchToProps = {
    loadPurchasedItems,
    UpdatePurchasedItemsConfigSelection,
};

const mapStateToProps = (state: CustomApplicationState) => ({
    purchasedItemsData: getPurchasedItemsData(state),
    purchasedItemsConfig: getPurchasedItemsConfigSelectionState(state),
    location: getLocation(state),
});

type Props = ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps> & HasHistory;

export interface PurchasedItemsContentStyles {
    wrapper?: InjectableCss;
    centeringWrapper?: InjectableCss;
    spinner?: LoadingSpinnerProps;
}

export const purchasedItemsContentStyles: PurchasedItemsContentStyles = {
    wrapper: {
        css: css`
            margin-top: 20px;
        `,
    },
    centeringWrapper: {
        css: css`
            height: 300px;
            display: flex;
            align-items: center;
        `,
    },
    spinner: {
        css: css`
            margin: auto;
        `,
    },
};

const styles = purchasedItemsContentStyles;
const purchasedItemsContentWidget: React.FC<Props> = ({
    loadPurchasedItems,
    UpdatePurchasedItemsConfigSelection,
    purchasedItemsData,
    purchasedItemsConfig,
    history,
    location: { pathname, search },
}) => {
    // useEffect(() => {
    //     loadPurchasedItems({});
    // }, []);

    const isInitialMount = React.useRef(true);
    const tzOffset = new Date().getTimezoneOffset() * 60000;
    const initfromDate = new Date(
        Date.now() - 90 * 60 * 60 * 24 * 1000 - tzOffset,
    );
    const inittoDate = new Date(
        Date.now() - tzOffset,
    );
    useEffect(() => {
        if (!purchasedItemsData.isLoading) {
            const data = new URLSearchParams(search);
            const updatedCnfigSelection: PurchasedItemsConfigParameter = {
                [configKey.page]: data.get(configKey.page) ? data.get(configKey.page)?.toString() : "",
                [configKey.Search]: data.get(configKey.Search) ? data.get(configKey.Search)?.toString() : "",
                [configKey.Description]: data.get(configKey.Description)
                    ? data.get(configKey.Description)?.toString()
                    : "",
                 [configKey.fromDate]: data.get(configKey.fromDate) ? data.get(configKey.fromDate)?.toString() : initfromDate.toISOString().split("T")[0],
                [configKey.toDate]: data.get(configKey.toDate) ? data.get(configKey.toDate)?.toString() :inittoDate.toISOString().split("T")[0],
            };
            UpdatePurchasedItemsConfigSelection(updatedCnfigSelection);
            loadPurchasedItems(updatedCnfigSelection);
        }
    }, [search]);

    useEffect(() => {
        if (isInitialMount.current) {
            isInitialMount.current = false;
        } 
        else 
        // if (!purchasedItemsData.isLoading) 
        {
            const configOrder = [configKey.page, configKey.Search, configKey.Description, configKey.fromDate, configKey.toDate];
            let param = "";
            for (const config of configOrder) {
                if (
                    purchasedItemsConfig &&
                    purchasedItemsConfig[config] &&
                    purchasedItemsConfig[config].toString() !== ""
                ) {
                    param += param !== "" ? "&" : "";
                    param += `${config}=${purchasedItemsConfig[config]}`;
                }
            }
            if (param.length) {
                const currentUrl = `${pathname}${search}`;
                const newUrl = `${pathname}?${param}`;
                if (newUrl !== currentUrl) {
                    history.push(newUrl);
                }
            }
            else{
                const currentUrl = `${pathname}`;
                history.push(currentUrl);
            }

            loadPurchasedItems({
                Search: purchasedItemsConfig[configKey.Search] || "",
                Description: purchasedItemsConfig[configKey.Description] || "",
                page: purchasedItemsConfig[configKey.page] || "",
                pageSize: purchasedItemsConfig[configKey.pageSize] || "",
                fromDate: purchasedItemsConfig[configKey.fromDate] || "",
                toDate: purchasedItemsConfig[configKey.toDate] || "",
            });
        }
    }, [purchasedItemsConfig]);

    if (purchasedItemsData.isLoading) {
        return (
            <StyledWrapper {...styles.centeringWrapper}>
                <LoadingSpinner {...styles.spinner} />
            </StyledWrapper>
        );
    }

    return (
        <>
            <StyledWrapper {...styles.wrapper}>
                {purchasedItemsData.isLoading === false ? <PurchasedItems></PurchasedItems> : null}
            </StyledWrapper>
        </>
    );
};
const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(withHistory(purchasedItemsContentWidget)),
    definition: {
        group: "Basic",
        icon: "LinkList",
        fieldDefinitions: [],
    },
};

export default widgetModule;
